module.exports = __webpack_public_path__ + "img/symbol_3.4aea197b.png";